document.addEventListener("DOMContentLoaded", () => {

    const isProductPage =
    document.body.classList.contains("template-product") ||
    window.location.pathname.includes("/products/");

    if (!isProductPage) return;
    
  const productSlugEl = document.getElementById("product_slug");
  const storeNameEl = document.getElementById("store_name");
  const discountEl = document.getElementById("discount");

  if (!productSlugEl || !storeNameEl || !discountEl) return;

  const productSlug = productSlugEl.value?.trim() || "";
  const storeName = storeNameEl.value?.trim();

  if (!storeName) return;

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function createDiscountHTML(data) {
    return `
      <form id="loyaltyForm">
        <div
          id="loggedIn-single-product-discount-phoneNum"
          class="single-product-discount-wrapper"
          style="background:${data.frame_color}!important;padding:25px 25px 45px!important;margin:0!important;max-width:44rem!important;font-weight:300!important;"
        >
          <h3
            class="single-product-discount-title"
            style="color:${data.header_text_color}!important;font-weight:300!important;"
          >
            ${data.header_text || ""}
          </h3>

          <div
            class="single-product-discount-sign-up-benefit-wrapper"
            style="background:#FFFFFF!important;border:1px solid #E3E4DE!important;padding:10px 15px!important;"
          >
            ${data.description || ""}
          </div>

          <div
            class="single-product-discount-input-wrapper"
            style="display:flex!important;justify-content:space-between!important;margin-top:15px!important;"
          >
            <input
              class="single-product-discount-input-textInput"
              type="text"
              required
              id="email_field"
              placeholder="Din epost"
              name="email"
              style="background:${data.email_color}!important;border-radius:0!important;border-width:1px!important;width:70%!important;padding:5px 15px!important;"
            >
            <button
              id="phoneNum-submitBtn"
              class="single-product-discount-input-submitBtn"
              type="submit"
              style="width:28%!important;cursor:pointer;color:${data.button_color}!important;background:${data.button_background}!important;font-weight:300!important;border:1px solid black!important;font-size:14px;"
            >
              ${data.button_text || "Submit"}
            </button>
          </div>
        </div>
      </form>
    `;
  }

  function applyMobileStyles() {
    if (!window.matchMedia("(max-width: 600px)").matches) return;

    document.querySelectorAll(".single-product-discount-sign-up-benefit-title").forEach(el => {
      el.style.fontSize = "13px";
    });

    document.querySelectorAll(".single-product-discount-sign-up-benefits").forEach(el => {
      el.style.marginLeft = "0";
    });

    document.querySelectorAll(".single-product-discount-sign-up-benefits li").forEach(el => {
      el.style.textAlign = "start";
    });
  }

  function showError(message) {
    const wrapper = document.getElementById("loggedIn-single-product-discount-phoneNum");
    if (!wrapper) return;

    const existingError = document.getElementById("errormsg");
    if (existingError) existingError.remove();

    const error = document.createElement("p");
    error.id = "errormsg";
    error.textContent = message;
    error.style.color = "red";
    error.style.fontSize = "12px";
    error.style.margin = "0";
    error.style.padding = "0";

    wrapper.appendChild(error);
  }

  function bindForm() {
    const form = document.getElementById("loyaltyForm");
    const emailField = document.getElementById("email_field");

    if (!form || !emailField) return;

    form.addEventListener("submit", event => {
      event.preventDefault();

      const existingError = document.getElementById("errormsg");
      if (existingError) existingError.remove();

      const emailValue = emailField.value.trim();

      if (!emailRegex.test(emailValue)) {
        showError("Vennligst skriv inn en gyldig e-postadresse");
        return;
      }

      window.location.href =
        `/a/loyalty?email=${encodeURIComponent(emailValue)}&product_slug=${encodeURIComponent(productSlug)}`;
    });
  }

  fetch("https://dialog.modish.no/api/discount-attributes", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      store_name: storeName
    })
  })
    .then(response => {
      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      if (Number(data.status) !== 1) return;

      discountEl.innerHTML = createDiscountHTML(data);
      applyMobileStyles();
      bindForm();
    })
    .catch(error => {
      console.error("Failed to load discount attributes:", error);
    });
});